import UserPage, { IUserPageAttrs } from '../components/UserPage';
import DiscussionList from '../components/DiscussionList';
import DiscussionListState from '../states/DiscussionListState';
import type Mithril from 'mithril';
import type User from '../../common/models/User';
import app from '../app';

/**
 * The `DiscussionsUserPage` component shows a discussion list inside of a user
 * page.
 */
export default class CollectionsUserPage extends UserPage<IUserPageAttrs, DiscussionListState> {
  oninit(vnode: Mithril.Vnode<IUserPageAttrs, this>) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
    app.current.set('page', this);
  }
  onremove() {
    // 注销当前页面
    app.current.set('page', null);
  }
  show(user: User): void {
    super.show(user);
    this.state = new DiscussionListState({
      filter: { subscription : 'following-' + user.id()},
      sort: 'newest',
    });

    this.state.refresh();
  }

  content() {
    return (
      <div className="DiscussionsUserPage">
        <DiscussionList state={this.state} />
      </div>
    );
  }
}
